module.exports = __webpack_public_path__ + "img/speaker-AdamNeuhaus.14faf60b.png";